import React, { useEffect } from "react";
import { FaUsers, FaHandsHelping, FaGraduationCap, FaHandSparkles, FaBook, FaHeart, FaTools, FaFemale, FaChild, FaBan } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Programs.css";

const programs = [
  { id: 1, title: "Making Community Leaders Self-Reliant", desc: "Empowering community leaders with skills and resources for sustainable development.", icon: <FaUsers />, delay: 100 },
  { id: 2, title: "Awareness Training on Social Issues", desc: "Conducting training programs to spread awareness on critical social issues.", icon: <FaHandsHelping />, delay: 150 },
  { id: 3, title: "Awareness on Drug Eradication", desc: "Initiatives to educate and eliminate drug abuse in vulnerable communities.", icon: <FaBan />, delay: 200 },
  { id: 4, title: "Awareness Program on Cleanliness", desc: "Promoting hygiene and sanitation to improve health and well-being.", icon: <FaHeart />, delay: 250 },
  { id: 5, title: "Making Women and Children Literate", desc: "Providing education to underprivileged women and children for a better future.", icon: <FaGraduationCap />, delay: 300 },
  { id: 6, title: "Relief for Disaster-Affected People", desc: "Distributing essential supplies to those affected by natural disasters.", icon: <FaHandsHelping />, delay: 350 },
  { id: 7, title: "Assistance to Orphans and Widows", desc: "Providing emotional and financial support to orphans and widows.", icon: <FaHeart />, delay: 400 },
  { id: 8, title: "Skill Development Training for Youth", desc: "Organizing camps to teach youth essential skills for employment and self-reliance.", icon: <FaTools />, delay: 450 },
  { id: 9, title: "Women Empowerment Seminars", desc: "Seminars and programs to inspire and uplift women in society.", icon: <FaFemale />, delay: 500 },
  { id: 10, title: "Ending Dowry System and Child Marriage", desc: "Spreading awareness and advocating against dowry practices and child marriage.", icon: <FaChild />, delay: 550 },
];

const Programs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="programs-section-home" id="programs-section">
      <div className="programs-container-home">
        <h2 className="programs-title-home" data-aos="fade-up">
          Our <span>Programs</span>
        </h2>

        <div className="programs-grid-home">
          {programs.map((program) => (
            <div
              className="program-card-home"
              key={program.id}
              data-aos="fade-up"
              data-aos-delay={program.delay}
            >
              <div className="program-icon-home">{program.icon}</div>
              <h3 className="program-title-home">{program.title}</h3>
              <p className="program-desc-home">{program.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;
